import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './order.reducer';

export const OrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const orderEntity = useAppSelector(state => state.order.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="orderDetailsHeading">Order</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{orderEntity.id}</dd>
          <dt>
            <span id="orderId">Order Id</span>
          </dt>
          <dd>{orderEntity.orderId}</dd>
          <dt>
            <span id="date">Date</span>
          </dt>
          <dd>{orderEntity.date ? <TextFormat value={orderEntity.date} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="deliveryDate">Delivery Date</span>
          </dt>
          <dd>{orderEntity.deliveryDate ? <TextFormat value={orderEntity.deliveryDate} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="status">Status</span>
          </dt>
          <dd>{orderEntity.status}</dd>
          <dt>
            <span id="totalAmount">Total Amount</span>
          </dt>
          <dd>{orderEntity.totalAmount}</dd>
          <dt>
            <span id="savingAmount">Saving Amount</span>
          </dt>
          <dd>{orderEntity.savingAmount}</dd>
          <dt>
            <span id="promocode">Promocode</span>
          </dt>
          <dd>{orderEntity.promocode}</dd>
          <dt>
            <span id="address">Address</span>
          </dt>
          <dd>{orderEntity.address}</dd>
          <dt>
            <span id="cityId">City Id</span>
          </dt>
          <dd>{orderEntity.cityId}</dd>
          <dt>
            <span id="pincode">Pincode</span>
          </dt>
          <dd>{orderEntity.pincode}</dd>
          <dt>
            <span id="shedule">Shedule</span>
          </dt>
          <dd>{orderEntity.shedule}</dd>
          <dt>
            <span id="noofitems">Noofitems</span>
          </dt>
          <dd>{orderEntity.noofitems}</dd>
          <dt>
            <span id="dcharges">Dcharges</span>
          </dt>
          <dd>{orderEntity.dcharges}</dd>
          <dt>
            <span id="hcharges">Hcharges</span>
          </dt>
          <dd>{orderEntity.hcharges}</dd>
          <dt>
            <span id="dvendor">Dvendor</span>
          </dt>
          <dd>{orderEntity.dvendor}</dd>
          <dt>
            <span id="latitude">Latitude</span>
          </dt>
          <dd>{orderEntity.latitude}</dd>
          <dt>
            <span id="logitude">Logitude</span>
          </dt>
          <dd>{orderEntity.logitude}</dd>
          <dt>
            <span id="paymentStatus">Payment Status</span>
          </dt>
          <dd>{orderEntity.paymentStatus}</dd>
          <dt>
            <span id="paymentType">Payment Type</span>
          </dt>
          <dd>{orderEntity.paymentType}</dd>
          <dt>
            <span id="dtip">Dtip</span>
          </dt>
          <dd>{orderEntity.dtip}</dd>
          <dt>
            <span id="vendorId">Vendor Id</span>
          </dt>
          <dd>{orderEntity.vendorId}</dd>
          <dt>
            <span id="vendorName">Vendor Name</span>
          </dt>
          <dd>{orderEntity.vendorName}</dd>
          <dt>
            <span id="mobile">Mobile</span>
          </dt>
          <dd>{orderEntity.mobile}</dd>
          <dt>
            <span id="dmobile">Dmobile</span>
          </dt>
          <dd>{orderEntity.dmobile}</dd>
          <dt>
            <span id="vmobile">Vmobile</span>
          </dt>
          <dd>{orderEntity.vmobile}</dd>
          <dt>
            <span id="timing">Timing</span>
          </dt>
          <dd>{orderEntity.timing}</dd>
        </dl>
        <Button tag={Link} to="/order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/order/${orderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default OrderDetail;
